/**
 * @file
 * @prettier
 */

import { InitializeAutoDebitEnrollmentPages } from "./AutoDebitEnrollmentPages.js";

export function InitializeSecureBorrowerAutoDebitEnrollment3reviewPage() {
  InitializeAutoDebitEnrollmentPages();
}
